import React from "react"
import styled from "styled-components"
import * as Icons from "../assets/Icons"

const Icon = ({ name, style, color, size }) => {
  const Icon = Icons[name]
  if (Icon) {
    const style = { width: size, height: size }
    return (
      <div>
        <Icon name={name} color={color} size={size} />
      </div>
    )
  } else {
    return null
  }
}

Icon.displayName = "Icon"

Icon.defaultProps = {
  size: 16,
  color: "#6079F2"
}

export default Icon



// WEBPACK FOOTER //
// ./src/components/Icons.js